// src/api/index.js
import { ApiClient } from "./ApiClient";
import { UserAPI } from "./endpoints/UserAPI";
import { MasterAPI } from "./endpoints/MasterAPI";
import { ContactsAPI } from "./endpoints/ContactsAPI";
import { OPDAPI } from "./endpoints/OPDAPI";
import { RoleAPI } from "./endpoints/RoleAPI";
import { IVFAPI } from "./endpoints/IVFAPI";
import { CommunicationsAPI } from "./endpoints/CommunicationsAPI";
import { EmbroTransferAPI } from "./endpoints/EmbroTransferAPI";
import { EmbryoFetMonitoringAPI } from "./endpoints/EmbryoFetMonitoringAPI";
import { EmbryoOutcomeAPI } from "./endpoints/EmbryoOutcomeAPI";
import { PharmacyAPI } from "./endpoints/PharmacyAPI";
import { AppointmentAPI } from "./endpoints/AppointmentAPI";
import { OpdBillingAPI } from "./endpoints/OpdBillingAPI";
import { FileUploadApi } from "./FileUploadApi";

const userBaseURL = process.env.REACT_APP_USER_API_BASE_URL || "http://localhost:4000";
const masterBaseURL = process.env.REACT_APP_MASTER_API_BASE_URL || "http://localhost:4005";
const contactsBaseURL = process.env.REACT_APP_CONTACTS_API_BASE_URL || "http://localhost:4002";
const opdBaseURL = process.env.REACT_APP_OPD_API_BASE_URL || "http://localhost:4004";
const ivfBaseURL = process.env.REACT_APP_IVF_API_BASE_URL || "http://localhost:4003";
const communicationsBaseURL = process.env.REACT_APP_COMMUNICATIONS_API_BASE_URL || "http://localhost:4001";
const pharmacyBaseURL = process.env.REACT_APP_PHARMACY_API_BASE_URL || "http://localhost:4006";

const userApiClient = new ApiClient(userBaseURL);
const masterApiClient = new ApiClient(masterBaseURL);
const contactsApiClient = new ApiClient(contactsBaseURL);
const opdApiClient = new ApiClient(opdBaseURL);
const ivfApiClient = new ApiClient(ivfBaseURL);
const communicationsApiClient = new ApiClient(communicationsBaseURL);
const pharmacyApiClient = new ApiClient(pharmacyBaseURL);
const fileUploadApi = new FileUploadApi(contactsBaseURL);

export const api = {
  auth: new UserAPI(userApiClient),
  user: new UserAPI(userApiClient),
  master: new MasterAPI(masterApiClient),
  contacts: new ContactsAPI(contactsApiClient),
  opd: new OPDAPI(opdApiClient),
  ivf: new IVFAPI(ivfApiClient),
  role: new RoleAPI(userApiClient),
  communications: new CommunicationsAPI(communicationsApiClient),
  embroTransfer: new EmbroTransferAPI(ivfApiClient),
  embryoFetMonitoring: new EmbryoFetMonitoringAPI(ivfApiClient),
  embryoOutcome: new EmbryoOutcomeAPI(ivfApiClient),
  pharmacy: new PharmacyAPI(pharmacyApiClient),
  appointment: new AppointmentAPI(opdApiClient),
  opdBilling: new OpdBillingAPI(opdApiClient),
  fileUploadApi: fileUploadApi,
};
